// Copy of the website's built-in "About Our Fabric" text (aavryaa_frontend
// Constants/aboutFabricContent.js). The admin editor shows these as the
// original values; only fields that differ are saved.
// `image: ""` means the bundled about-fabric.gif.
export const ABOUT_FABRIC_DEFAULTS = {
  processTitle: "Custom Print Process",
  step1Text: "We will Develop Design",
  step1Highlight: "Develop Design",
  image: "",
  step2Text: "We will print on fabric of your choice",
  step2Highlight: "print",
  badge: "Premium Custom Fabric",
  heading: "About Our Fabric",
  intro1: "At Aavryaa, fabric is more than a material—it is the beginning of a masterpiece. Every design is thoughtfully curated to celebrate elegance, individuality, and timeless beauty, offering a luxurious canvas for extraordinary creations.",
  intro2: "Our collection showcases an exquisite range of premium fabrics adorned with exclusive signature prints, sophisticated florals, contemporary motifs, and bespoke designs—developed to combine aesthetic excellence with superior quality for designers, boutiques, fashion houses, and discerning clientele.",
  pills: ["Signature Prints", "Premium Fabric Bases", "Design Confidential", "Bespoke Development"],
  button1Text: "Explore Our Ideas",
  button2Text: "We will print on fabric of your choice",
  whatsappMessage: "Hi, I'm interested in custom fabric printing",
  story: "Driven by a passion for surface pattern design, we specialize in creating distinctive textile stories that transform creative visions into reality. From graceful ethnic wear and statement sarees to couture-inspired gowns, designer ensembles, and contemporary fashion collections, our fabrics are crafted to elevate every garment they become a part of.",
  bespokeTitle: "Bespoke Print Development",
  bespoke1: "Luxury lies in exclusivity. We offer customized fabric printing services that enable brands, designers, boutiques, and manufacturers to bring their unique concepts to life. From initial inspiration and artwork development to final production, every stage is executed with precision and attention to detail.",
  bespoke2: "Whether inspired by nature, art, heritage, or modern aesthetics, your ideas are translated into exceptional prints that reflect your signature style and brand identity.",
  specialtiesTitle: "Our Specialties",
  specialties: [
    "Exclusive Signature Floral Collections",
    "Bespoke Surface Pattern Designs",
    "Premium Quality Fabric Bases",
    "Custom Colourways & Design Development",
    "Boutique & Designer Exclusive Prints",
    "Fashion Brand Private Label Printing",
    "Ethnic, Contemporary & Fusion Wear Fabrics",
    "End-to-End Design Consultation",
  ],
  bulkTitle: "Bulk Production",
  bulkText: "We undertake bulk orders for customized prints tailored to your specific requirements.",
  minLabel: "Minimum Order",
  minValue: "100 Metres",
  minUnit: "per design",
  closing: "At Aavryaa, we create fabrics that inspire designers, empower brands, and transform imagination into timeless fashion.",
  tagline: "Where Art Meets Fabric. Where Fabric Becomes Fashion.",
};

// Maximum length of each field, so new text can't break the section's layout.
// Lists: max items and max letters per item. Keep in step with the backend
// (routes/siteContentRoutes.js).
export const ABOUT_FABRIC_LIMITS = {
  processTitle: 28, step1Text: 40, step1Highlight: 40, step2Text: 45, step2Highlight: 45,
  badge: 28, heading: 26, intro1: 280, intro2: 340,
  pills: { items: 6, each: 24 },
  button1Text: 22, button2Text: 42, whatsappMessage: 200,
  story: 420, bespokeTitle: 32, bespoke1: 360, bespoke2: 220,
  specialtiesTitle: 24, specialties: { items: 10, each: 48 },
  bulkTitle: 24, bulkText: 120, minLabel: 16, minValue: 14, minUnit: 14,
  closing: 150, tagline: 64,
};
